var _a;
import { SORT_DIRECTION } from 'constants/app.constant';
var ehrBasePath = '/eaqHesiReadiness';
export var ehrPath = {
    ehrHome: ehrBasePath,
    ehrHomeByTopicAndChapter: "".concat(ehrBasePath, "#byTopicAndChapter"),
    ehrHomeByStudent: "".concat(ehrBasePath, "#byStudent"),
    ehrStudentDetail: "".concat(ehrBasePath, "/studentDetail/:studentId")
};
export var EHR_HOME_TAB_INDEXES = {
    byTopicAndChapter: 0,
    byStudent: 1
};
export var MASTERY_LEVELS_CONFIGS = {
    proficient: {
        key: 'proficient',
        field: 'proficient',
        color: 'chart-green-3',
        label: 'Proficient',
        scoreRange: '(3.0-3.9)'
    },
    intermediate: {
        key: 'intermediate',
        field: 'intermediate',
        color: 'chart-green-2',
        label: 'Intermediate',
        scoreRange: '(2.0-2.9)'
    },
    novice: {
        key: 'novice',
        field: 'novice',
        color: 'chart-green-1',
        label: 'Novice',
        scoreRange: '(1.0-1.9)'
    },
    preNovice: {
        key: 'preNovice',
        field: 'preNovice',
        color: 'chart-grey-1',
        label: 'Incomplete',
        scoreRange: '(0-0.9)'
    }
};
export var masteryLevels = Object.values(MASTERY_LEVELS_CONFIGS).reverse();
export var MASTERY_MAX_POINT = 4;
export var CHAPTER = 'Chapter';
export var TAXONOMY = 'TAXONOMY';
export var TABLE_SETTINGS = {
    MAX_HEIGHT: '502px',
    DEFAULT_SORT: 'desc',
    SORT_ICON_SIZE: '3o4',
    DEFAULT_SORT_FIELD: 'students',
    // Minumin row to show scroll down
    SHOW_ICON: 14
};
export var StudentPerformanceLevels = Object.freeze({
    Incomplete: 0,
    Novice: 1,
    Intermediate: 2,
    Proficient: 3
});
export var EHR_NA_VALUE = '-';
export var STUDENT_PERFORMANCE_LEVEL_CHART_ID = {
    studentsWithZeroSubmissions: 'STUDENTS_WITH_ZERO_SUBMISSION',
    studentsBelowNovice: 'STUDENTS_BELOW_NOVICE'
};
export var EHR_STUDENT_SORT_FIELD = {
    studentNameColumn: 'fullName',
    studentMasteryLevelColumn: 'masteryLevel',
    percentCorrectColumn: 'percentCorrect',
    numberOfQuestionsAnsweredColumn: 'questionsAnswered',
    avgTimeSpentPerQuestionColumn: 'avgTimeSpentPerQuestion',
    lastDateTakenColumn: 'lastUpdatedDate'
};
export var EHR_STUDENT_TABLE_SELECTOR = {
    studentMasteryLevelColumn: 'c-ehr-student-table__student-performance-level-header-column',
    numberOfQuestionsAnsweredColumn: 'c-ehr-student-table__number-of-questions-answered-header-column',
    percentCorrectColumn: 'c-ehr-table__percent-correct-header-column'
};
export var EHR_STUDENT_DETAIL_CARD_ID = {
    studentMasteryLevel: 'EHR_STUDENT_DETAIL_MASTERY_LEVEL',
    questionsAnswered: 'EHR_STUDENT_DETAIL_QUESTIONS_ANSWERED',
    avgPercentCorrect: 'EHR_STUDENT_DETAIL_AVG_PERCENT_CORRECT'
};
export var EHR_STUDENT_DETAIL_TABLE_SELECTOR = {
    studentMasteryLevelColumn: 'c-ehr-student-detail-table__student-mastery-level-header-column',
    avgPercentCorrectColumn: 'c-ehr-table__avg-percent-correct-header-column'
};
export var EHR_STUDENT_DETAIL_SORT_FIELD = {
    topic: 'chapter',
    studentMasteryLevel: 'masteryLevel',
    avgPercentCorrect: 'avgPercentCorrect',
    numberQuestionsAnswered: 'questionsAnswered',
    avgTimePerQuestion: 'avgTimePerQuestion'
};
export var EHR_INTERACTION_BETWEEN_CHART_AND_TABLE = (_a = {},
    _a[STUDENT_PERFORMANCE_LEVEL_CHART_ID.studentsWithZeroSubmissions] = {
        tableColumn: {
            headerSelector: EHR_STUDENT_TABLE_SELECTOR.studentMasteryLevelColumn
        },
        sortDirection: SORT_DIRECTION.ASC
    },
    _a[STUDENT_PERFORMANCE_LEVEL_CHART_ID.studentsBelowNovice] = {
        tableColumn: {
            headerSelector: EHR_STUDENT_TABLE_SELECTOR.numberOfQuestionsAnsweredColumn
        },
        sortDirection: SORT_DIRECTION.ASC
    },
    _a[EHR_STUDENT_DETAIL_CARD_ID.studentMasteryLevel] = {
        tableColumn: {
            headerSelector: EHR_STUDENT_DETAIL_TABLE_SELECTOR.studentMasteryLevelColumn
        },
        sortDirection: SORT_DIRECTION.ASC
    },
    _a[EHR_STUDENT_DETAIL_CARD_ID.avgPercentCorrect] = {
        tableColumn: {
            headerSelector: EHR_STUDENT_DETAIL_TABLE_SELECTOR.avgPercentCorrectColumn
        },
        sortDirection: SORT_DIRECTION.DESC
    },
    _a);
export var EHR_PRODUCT_NAME = 'ehr';
